import React, { Component } from 'react'
import List from '../components/Storingen/List';
import dynamicPortal from '../utils/dynamicPortal';

export class StoringenPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-storingen', (config) => (
      <List config={config} />
    ))
  }
}

export default StoringenPortal;


// WEBPACK FOOTER //
// ./src/portals/StoringenPortal.js